const namespace = 'bravissimo/email-signup';

export const EMAIL_OPT_IN = `${namespace}/EMAIL_OPT_IN`;
export const EMAIL_OPT_IN_SUCCESS = `${namespace}/EMAIL_OPT_IN_SUCCESS`;
export const EMAIL_OPT_IN_FAILURE = `${namespace}/EMAIL_OPT_IN_FAILURE`;
